import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/stylesAdministrativo1.css';

const Administrativo1 = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const elem = document.querySelector(hash);
      if (elem) elem.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash]);

  return (
    <section className="altaBajaPatentes">
      <div className="altaBajaPatentes__container">

        <h2 className="altaBajaPatentes__title">
          Alta y Baja de Patentes
        </h2>

        <p className="altaBajaPatentes__descripcion">
          A continuación le presentamos los enlaces oficiales de la Provincia de Santa Fe 
          donde se detalla el procedimiento para dar de alta o baja un vehículo. 
          También encontrará disponible para descarga el formulario 1057 requerido para estos trámites.
        </p>

        <div className="altaBajaPatentes__links">
          
          <a
            href="https://www.santafe.gob.ar/gestionesciudadanas/tramite/6909e67ce686c010ec01c25d"
            target="_blank"
            rel="noreferrer"
            className="altaBajaPatentes__link"
          >
            <span>Alta de vehículo</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
          </a>

          <a
            href="https://www.santafe.gob.ar/gestionesciudadanas/tramite/6909e558a98fef8ee90c8e9c"
            target="_blank"
            rel="noreferrer"
            className="altaBajaPatentes__link"
          >
            <span>Baja de vehículo</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
          </a>

          <a
            href="https://www.santafe.gov.ar/index.php/content/download/98485/485681/file/Formulario"
            target="_blank"
            rel="noreferrer"
            className="altaBajaPatentes__link"
          >
            <span>Descargar Formulario 1057</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
          </a>

          <a
            href="https://www.santafe.gov.ar/index.php/web/content/view/full/208515/(subtema)/207002"
            target="_blank"
            rel="noreferrer"
            className="altaBajaPatentes__link"
          >
            <span>Preguntas frecuentes</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
          </a>

        </div>

      </div>
    </section>
  );
}

export default Administrativo1;